import { Platform } from 'react-native';
import AsyncStorage from '@react-native-community/async-storage';
import * as ActionTypes from '../constants';
import axios from 'axios'; 
import {baseUrl,getUserToken } from './index'; 
// import RNFetchBlob from 'rn-fetch-blob' 



const dispatchRequestUploadProfile = uploadProfileData => ({
    type:ActionTypes.REQUEST_UPLOAD_PROFILE,
    uploadProfileData
})

const dispatchReceivedUploadProfile = res =>({
    type:ActionTypes.RECEIVED_UPLOAD_PROFILE,
    res
})

const dispatchErrorUploadProfile = (err) => ({
    type:ActionTypes.ERROR_UPLOAD_PROFILE,
    err
})

const dispatchClearUploadProfile= () => ({
    type: ActionTypes.CLEAR_UPLOAD_PROFILE
})

export const clearUploadProfileData = () => dispatchClearUploadProfile();

// export const uploadProfilePic = (uploadProfileData, fileName) => dispatch => {
export const uploadProfilePic = (fileName) => dispatch => {

    dispatch(dispatchRequestUploadProfile(fileName));    
    // const imagePath = Platform.OS === "android" ? uploadProfileData : uploadProfileData.replace("file://", "");


    // const data = {
    //     first_name: 'light',
    //     last_name: 'yagami',
    //     // email: 'testmail@mail.com',
    //     city: 'warangal',
    //     address: 'mars'
    // }

    getUserToken()
        .then( async (authKey) => {

            // const options = {
            //     method: 'post',
            //     url: `${baseUrl}/api/edit_profile_pic`,
            //     data:{
            //         name : 'profile_pic',
            //         filename : 'avatar.jpg',
            //         type: 'image/jpeg',
            //         // Change BASE64 encoded data to a file path with prefix `RNFetchBlob-file://`.
            //         // Or simply wrap the file path with RNFetchBlob.wrap().
            //         data: fileName
            //         }, 
                     
            //     headers: {
            //         'Authorization': `Bearer ${authKey}`,
                    
            //     }
            // }
            axios({
                method: 'post',
                url: `${baseUrl}/api/edit_profile_pic`,
                data:{
                    name : 'profile_pic',
                    filename : 'avatar.jpg',
                    type: 'image/jpeg',
                    // Change BASE64 encoded data to a file path with prefix `RNFetchBlob-file://`.
                    // Or simply wrap the file path with RNFetchBlob.wrap().
                    data: fileName
                    }, 
                     
                headers: {
                    'Authorization': `Bearer ${authKey}`,
                    
                }         
            })          
            .then(({data}) => {            
                dispatch(dispatchReceivedUploadProfile(data));            
            })
            .catch(e => {
                dispatch(dispatchErrorUploadProfile(e.response))
            })  
            
            // const photo = await AsyncStorage.getItem('profilePic');            
            // fetch('POST', `${baseUrl}/api/edit_profile_pic`, {
            //     Authorization : `Bearer ${authKey}`,
            //     // otherHeader : "foo",
            //     // this is required, otherwise it won't be process as a multipart/form-data request
            //     'Content-Type' : 'multipart/form-data',
            // }, [
            //     // append field data from file path
            //     {
            //     name : 'profile_pic',
            //     filename : 'avatar.jpg',
            //     type: 'image/jpeg',
            //     // Change BASE64 encoded data to a file path with prefix `RNFetchBlob-file://`.
            //     // Or simply wrap the file path with RNFetchBlob.wrap().
            //     data: fileName
            //     }                
            // ]).then(({data}) => {  
            //     let _data = data;
            //     if(typeof data === 'string') _data = JSON.parse(data);
            //     dispatch(dispatchReceivedUploadProfile(_data))
            // }).catch((e) => {
            //     console.log(e, 'error from upload profile rn fetch', e.response);  
            //     dispatch(dispatchErrorUploadProfile(e.response));
            // })
          

            // axios(options)
            //     .then(res => dispatchReceivedUploadProfile(res))
            //     .catch(e => dispatchErrorUploadProfile(e))

        })
        // .catch(e =>{
        //     // console.log(e, e.response);
        //     dispatch(dispatchErrorUploadProfile(e.response))
        // });    
}